import React from 'react'

const SvgMale = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.002 10.5a1 1 0 01-2 0l-.001-2.616-3.148 3.093a6 6 0 11-1.429-1.4L16.557 6.5H14l-.102-.004A1 1 0 0114 4.502l5.002-.002a1 1 0 011 1v5zM10 10.502a4 4 0 102.895 1.242 1.006 1.006 0 01-.22-.215A3.985 3.985 0 0010 10.502z'
    />
  </svg>
)

export default SvgMale
